function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "square",
  d: "M24,17.5542443 L24,9.52936421 L24,17.5542443 Z M28.2750211,19.1342282 L33.3549485,12.9868134 L28.2750211,19.1342282 Z M30.5497123,23.134888 L38.3326126,21.7413822 L30.5497123,23.134888 Z M29.7597203,27.6842704 L36.603888,31.6967104 L29.7597203,27.6842704 Z M26.2746912,30.6536689 L28.9776641,38.1945894 L26.2746912,30.6536689 Z M21.7253088,30.6536689 L19.0223359,38.1945894 L21.7253088,30.6536689 Z M18.2402797,27.6842704 L11.396112,31.6967104 L18.2402797,27.6842704 Z M17.4502877,23.134888 L9.66738739,21.7413822 L17.4502877,23.134888 Z M19.7249789,19.1342282 L14.6450515,12.9868134 L19.7249789,19.1342282 Z"
});

var SvgSmoothness = function SvgSmoothness(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSmoothness, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smoothness.4ce21f4f.svg";
export { ForwardRef as ReactComponent };